var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 195,
    viewBox: "0 0 143 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3292_5220)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3672 115.563L73.852 125.08L40.3766 183.061L30.7685 161.633L57.3672 115.563Z",
    fill: "#CE4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3672 115.563L40.8824 106.045L7.40705 164.026L30.7685 161.633L57.3672 115.563Z",
    fill: "#983535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8867 115.563L64.4019 125.08L97.8773 183.061L107.485 161.633L80.8867 115.563Z",
    fill: "#983535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8867 115.563L97.3715 106.045L130.847 164.026L107.485 161.633L80.8867 115.563Z",
    fill: "#CE4444"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.6211,
    cy: 75.6406,
    r: 57.2539,
    fill: "url(#paint0_linear_3292_5220)",
    stroke: "#765C00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.6219,
    cy: 75.6409,
    r: 44.3016,
    fill: "#A88300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3292_5220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 35,
    width: 90,
    height: 90
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.9867,
    cy: 80.3705,
    r: 44.4047,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3292_5220)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.6234,
    cy: 75.641,
    r: 44.4047,
    fill: "#C09525"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8612 44.7495L78.4399 63.9069L97.5973 66.3016L84.4425 81.0529L88.0186 102.222L68.8612 92.6431L49.7037 102.222L53.3117 81.0529L40.125 66.3016L59.2824 63.9069L68.8612 44.7495Z",
    fill: "url(#paint1_linear_3292_5220)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7468 41.2361L19.9924 27.4907L13.7468 13.7454L27.4922 19.9909L41.2376 13.7454L34.992 27.4907L41.2376 41.2361L27.4922 34.9905L13.7468 41.2361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3292_5220",
    x: 6.62275,
    y: 12.9621,
    width: 135.977,
    height: 181.852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3292_5220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3292_5220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3292_5220",
    x1: 68.6211,
    y1: 18.8867,
    x2: 68.6211,
    y2: 132.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3292_5220",
    x1: 68.8612,
    y1: 44.7495,
    x2: 68.8612,
    y2: 102.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE896"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/gold_medal.538d12c23cc3f11e19e0a18980434ce0.svg";
export { ForwardRef as ReactComponent };